import { render, staticRenderFns } from "./PreviewWeb.vue?vue&type=template&id=1cc5c0b4&scoped=true"
import script from "./PreviewWeb.vue?vue&type=script&lang=js"
export * from "./PreviewWeb.vue?vue&type=script&lang=js"
import style0 from "./PreviewWeb.vue?vue&type=style&index=0&id=1cc5c0b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc5c0b4",
  null
  
)

export default component.exports